      var swiper = new Swiper(".mySwiper", {
     

           breakpoints: {
        // when window width is <= 499px
        0: {

            slidesPerView: 1.5,
            centeredSlides:true,
            spaceBetween: 50,
          navigation:{
            enabled:false,
          },
          loop:true
        },
        // when window width is <= 999px
        999: {
       slidesPerView: 6,
            loop:true,
        
        slideToClickedSlide:true,
        spaceBetween: 30

    
        }
    },
  
     navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
      });

  
  var swiper = new Swiper('.slideSwiper', { 
        slidesPerView:7,
        spaceBetween:40,    
        loop:true,
        nextButton: '.swiper-btn-next',
        prevButton: '.swiper-btn-prev',
        navigation:{
               enabled:true,
             nextEl: '.swiper-btn-next',
             prevEl: '.swiper-btn-prev',

      },
      breakpoints: {
    // when window width is >= 0
    100: {
      slidesPerView: 2.5,
      spaceBetween: 20,
          navigation:{
               enabled:false,
   

      }
    },
  
    // when window width is >= 640px
    640: {
  slidesPerView:7,
spaceBetween:40,
      loop:false,
        navigation:{
               enabled:true,
   

      }
    }
  }

   
});

